export class AwsEc2SnapshotProperties {
    'instanceType';
    'subnetId';
    'securityGroupIds';
    'instanceProfileName';
    'volumes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceType",
            "baseName": "instanceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "instanceProfileName",
            "baseName": "instanceProfileName",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<InventorySnapshotVolume>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2SnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
